// extracted by mini-css-extract-plugin
module.exports = {"positioning":"ReleasedDatasetsDashboard_positioning__3Ub1K","chart_released":"ReleasedDatasetsDashboard_chart_released__3swfV"};